<template>
  <div class="pb-2">
    <div v-if="this.loadpage == false" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == true">

      <!-- balance card -->
      <b-row class="match-height">
        <b-col xl="6" md="6">
          <b-card>
            <b-card-header class="px-0">
              <h4 class="mb-0 font-weight-bolder card-paid">
                เงินบาท
              </h4>
            </b-card-header>
            <div class="text-center">
              <h2
                class="font-weight-bold"
                :class="this.balanceUser.balanceBaht >= 0 ? 'text-success' : 'text-danger'"
              >
                {{format_price(this.balanceUser.balanceBaht)}}
              </h2>
              <h4>บาท</h4>
            </div>
            <div class="text-right pt-1">
              <!-- <b-button variant="primary" size="sm" v-b-modal.topup-baht>เติม Balance</b-button> -->
              <b-button variant="primary" size="sm" @click="toTopupBalance">เติม Balance</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col xl="6" md="6">
          <b-card>
            <b-card-header class="px-0">
              <h4 class="mb-0 font-weight-bolder card-nopaid">
                เงินหยวน
              </h4>
            </b-card-header>
            <div class="text-center">
              <h2
                class="font-weight-bold"
                :class="this.balanceUser.balanceYuan >= 0 ? 'text-success' : 'text-danger'"
              >
                {{format_price(this.balanceUser.balanceYuan)}}
              </h2>
              <h4>หยวน</h4>
            </div>
            <div class="text-right pt-1">
              <b-button variant="primary" size="sm" v-b-modal.topup>แลกเงินหยวน</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <div class="pb-1">
        <b-button variant="primary" size="sm" v-b-modal.china-transfer>
          เพิ่มรายการโอนเงิน
        </b-button>
      </div>

      <!-- transfer table -->
      <b-card>
        <b-card-body class="d-flex pt-1 pb-0">
          <div class="d-flex align-items-center mb-1 ">
            <span class="px-0 col-1"> วันที่: </span>
            <flat-pickr v-model="date" class="form-control" :config="datePickerConfig"/>
            <span class="px-1"> - </span>
            <span class="px-0 col-1"> ถึงวันที่: </span>
            <flat-pickr v-model="dueDate" class="form-control mr-1" :config="datePickerConfig"/>
            <b-button variant="primary" @click="getTransferList()">ค้นหา</b-button>
          </div>
        </b-card-body>
        <div class="text-right pt-1">จำนวนทั้งหมด : {{this.totalRows}}</div>
        <b-table
          responsive
          :items="paymentList"
          :fields="paymentFields"
          table-class="table-md-responsive text-nowrap"
        >
          <template #cell(id)="data">
            <feather-icon
              v-if="data.item.statusID == 2"
              :id="`confirm-${data.value}`"
              icon="CheckSquareIcon"
              class="cursor-pointer text-primary mr-1"
              size="20"
              @click="popupUpdate(data.item)"
            />
            <b-tooltip
              title="ยืนยันฝากจ่าย"
              :target="`confirm-${data.value}`"
              :delay="{show: '1000'}"
            />
            <feather-icon
              v-if="data.item.statusID <= 3"
              :id="`del-${data.value}`"
              icon="Trash2Icon"
              class="cursor-pointer text-danger"
              size="20"
              @click="deleteTransfer(data.value)"
            />
            <b-tooltip
              title="ลบรายการ"
              :target="`del-${data.value}`"
              :delay="{show: '1000'}"
            />
          </template>
          <template #cell(created)="data">
            <div>{{formatDatetime(data.value)}}</div>
          </template>
          <template #cell(amount)="data">
            <div>{{format_price(data.item.statusID >= 3 ? data.item.confirmAmount : data.value)}}</div>
          </template>
          <template #cell(paymentMethod)="data">
            <div>{{data.value == 'Bank Acoount' ? 'บัญชีจีน' : data.value}}</div>
          </template>
          <template #cell(photoLink)="data">
            <b-link v-if="data.value.length > 0" @click="showImgList(data.value)">ดูรูป</b-link>
          </template>
          <template #cell(transferSlip)="data">
            <b-img :src="data.value" class="cursor-pointer" width="50px" @click="showImg(data.value)"/>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </b-card>

      <!-- china transfer from btn - เพิ่มรายการโอนเงิน -->
      <b-modal
        ref="china-transfer"
        id="china-transfer"
        @hidden="closeChooseList"
        header-class="py-0 px-0 modal-header"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
      >
        <!-- step -->
        <div class="d-flex align-items-center pb-2 mt-n2">
          <div class="text-center mt-2">
            <b-avatar class="d-flex" variant="light-success" size="lg" text="1"/>
            <small>เลือกธุรกรรม</small>
          </div>
          <hr style="border-top: 1px solid inset; flex-grow: 1;">
          <div class="text-center mt-2">
            <b-avatar class="d-flex" :variant="stepPay >= 1 ? 'light-success' : 'light-secondary'" size="lg" text="2"/>
              <small>กรอกข้อมูล</small>
          </div>
        </div>

        <!-- body -->
        <div class="justify-content-md-center">

          <div v-if="stepPay == 0">
            <h4 class="text-center">เลือกรายการ</h4>
            <!-- <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5> -->
            <div class="pl-4 pt-1">
              <b-form-radio-group
                v-model="chooseMethod"
                stacked
              >
                <div v-for="list in paymentMethod" :key="list.length" class="pb-1 d-flex align-items-center">
                  <b-form-radio
                    :value="list.value"
                    class="pr-1"
                  >
                    {{list.text}}
                  </b-form-radio>
                </div>
              </b-form-radio-group>
            </div>
            <div class="text-right pt-1">
              <b-button variant="primary" @click="nextStep(1)">ถัดไป{{'>>'}}</b-button>
            </div>
          </div>

          <div v-if="stepPay == 1">
            <div v-if="this.chooseMethod == 1" class="pt-1">
              <div class="d-flex pb-1">
                <span class="pr-2">ฝากจ่าย :</span>
                <b-form-radio-group v-model="payWebSel">
                  <b-form-radio
                    v-for="list in payWebList" :key="list.length"
                    :value="list.value"
                    class="pr-1"
                  >
                    {{list.text}}
                  </b-form-radio>
                </b-form-radio-group>
              </div>
              <small v-if="this.valPayWebSel == false" class="text-danger">กรุณาเลือกที่ต้องการฝากจ่าย</small>
              <div>ยอดรวมฝากจ่าย :</div>
              <b-form-input v-model="depositAmount" @keypress="isNumberWithDot($event)"/>
              <small v-if="this.valDepositAmount == false" class="text-danger">กรุณาระบุยอดฝากจ่าย</small>
              <div class="pt-1">แนบรูปออร์เดอร์ :</div>
              <b-form-file v-model="imgFile" placeholder="Choose a file" drop-placeholder="Drop file here..."/>
              <div class="text-danger">*กรุณาแนบรูปออร์เดอร์ให้ครบ</div>
              <!-- <div>
                <b-link><u>คำแนะนำ</u></b-link>
              </div> -->
              <b-row class="pt-2">
                <b-col v-for="(item,index) in imgList" :key="index" class="col-6 col-md-4">
                  <span v-if="item.img64 != null">
                    <div class="text-right cursor-pointer" @click="removeImg(item)">
                      <feather-icon icon="XIcon" size="21"/>
                    </div>
                    <b-img :src="item.img64" fluid></b-img>
                  </span>
                </b-col>
              </b-row>
            </div>
            <div v-if="this.chooseMethod == 2" class="pt-1">
              <div>ยอด :</div>
              <b-form-input v-model="chinaAmount" @keypress="isNumberWithDot($event)"/>
              <small v-if="this.valChinaAmount == false" class="text-danger">กรุณาระบุยอด</small>
              <div class="pt-1">รายละเอียด :</div>
              <b-form-textarea v-model="chinaRemark" placeholder="เลขบัญชี, ชื่อบัญชี, ชื่อธนาคาร"/>
              <small v-if="this.valChinaRemark == false" class="text-danger">กรุณาระกรอกรายละเอียด</small>
              <div class="pt-1">แนบรูป :</div>
              <b-form-file v-model="imgOnce" placeholder="Choose a file" drop-placeholder="Drop file here..."/>
              <div class="text-danger">*จะแนบรูปหรือไม่ก็ได้</div>
            </div>
            <div v-if="this.chooseMethod == 3" class="pt-1">
              <div class="pt-1">ยอด :</div>
              <b-form-input v-model="alipayAmount" @keypress="isNumberWithDot($event)"/>
              <small v-if="this.valAlipayAmount == false" class="text-danger">กรุณาระบุยอด</small>
              <div class="pt-1">Account Alipay :</div>
              <b-form-textarea v-model="alipayRemark" placeholder="เลขบัญชี, ชื่อ Account Alipay"/>
              <small v-if="this.valAlipayRemark == false" class="text-danger">กรุณาระกรอกรายละเอียด</small>
              <div class="pt-1">แนบรูป :</div>
              <b-form-file v-model="imgOnce" placeholder="Choose a file" drop-placeholder="Drop file here..."/>
              <div class="text-danger">*จะแนบรูปหรือไม่ก็ได้</div>
            </div>
            <b-row class="pt-1">
              <b-col>
                <b-button variant="outline-danger" @click="nextStep(0)">{{'<<'}}กลับ</b-button>
              </b-col>
              <b-col class="text-right">
                <b-button variant="primary" @click="createTransfer" :disabled="this.loadbtn == false">
                  <b-spinner v-if="this.loadbtn == false" small/>
                  ยืนยัน
                </b-button>
              </b-col>
            </b-row>
          </div>

        </div>
      </b-modal>

      <!-- update transfer from btn in table -->
      <b-modal
        ref="update-transfer"
        id="update-transfer"
        @hidden="closeUpdate"
        header-class="py-0 px-0 modal-header"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
      >
        <div class="text-center h4 pb-1">ยืนยันฝากจ่าย</div>
        <b-row>
          <b-col class="col-4">จ่ายให้ :</b-col>
          <b-col class="col-8">{{this.confirmParMeth}}</b-col>
          <b-col class="col-4 pt-1">ยอดที่แจ้ง :</b-col>
          <b-col class="col-8 pt-1">{{format_price(this.confirmParAmount)}}</b-col>
        </b-row>
        <div class="pt-1">ยอดที่โอน :</div>
        <b-form-input v-model="confirmAmount" @keypress="isNumberWithDot($event)"/>
        <small v-if="this.valConfirmAmount == false" class="text-danger">กรุณาระบุยอดที่โอน</small>
        <div class="pt-1">แนบสลิป :</div>
        <b-form-file v-model="confirmSlip" placeholder="Choose a file" drop-placeholder="Drop file here..."/>
        <small>*แนบหรือไม่แนบก็ได้</small>
        <div class="text-right pt-1">
          <b-button @click="updateTransfer" variant="primary" :disabled="this.loadbtn == false">
            <b-spinner v-if="this.loadbtn == false" small/>
            ยืนยัน
          </b-button>
          <b-button @click="closeUpdate" variant="outline-danger" class="ml-1">ยกเลิก</b-button>
        </div>
      </b-modal>

      <!-- topup balance yuan from btn - แลกเงินหยวน-->
      <b-modal
        id="topup"
        ref="topup"
        @hidden="closeTopupBalance"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        <div class="text-center">
          <h3>กรุณาระบุจำนวนหยวนที่ต้องการเติม</h3>
          <h5 class="pb-1">
            คุณมี
            <span :class="this.balanceUser.balanceBaht >= 0 ? 'text-success' : 'text-danger'">
              {{format_price(this.balanceUser.balanceBaht)}}
            </span>
            บาท
          </h5>
          <b-row>
            <b-col class="col-12 d-flex align-items-center">
              <div class="col-3 pl-0 text-left pr-0">ต้องการแลก :</div>
              <b-form-input v-model="amountBaht" @keypress="isNumberWithDot($event)" @input="pressBaht"/>
              <div class="col-2 pl-0 text-right pr-0">บาท</div>
            </b-col>
            <b-col class="col-12 d-flex pt-1" >
              <div class="col-3 pl-0 text-left pr-0"></div>
              <div class="text-left">
                <div class="clr-text">เรทเติมเงิน : {{format_price(this.exchangeRate.topUpRate)}} / ค่าธรรมเนียม : {{format_price(this.exchangeFee.numberValues)}}</div>
                <div v-if="this.amountYuan != ''" class="clr-text pt-1">{{'( '}} {{format_price(this.amountBaht)}} - {{format_price(this.exchangeFee.numberValues)}} {{' )'}} ÷ {{format_price(this.exchangeRate.topUpRate)}} = {{format_price(this.amountYuan)}}</div>
              </div>
            </b-col>
            <b-col class="col-12 d-flex align-items-center pt-1">
              <div class="col-3 pl-0 text-left pr-0">แลกได้(หยวน) :</div>
              <b-form-input v-model="amountYuan" @keypress="isNumberWithDot($event)" @input="pressYuan"/>
              <div class="col-2 pl-0 text-right pr-0">หยวน</div>
            </b-col>
          </b-row>
          <small v-if="this.valAmountYuan == false" class="text-danger">กรุณาระบุจำนวนเงิน</small>
        </div>
        <div class="pt-2 text-right">
          <b-button  variant="primary" @click="exchangeBahtToYuan()" :disabled="this.loadbtn == false">
            <b-spinner v-if="this.loadbtn == false" small/>
            ยืนยัน
          </b-button>
        </div>
      </b-modal>
    </div>

    <!-- show img -->
    <b-modal ref="show-img" hide-footer centered>
      <div class="text-center">
        <b-img class="px-0" :src="this.imgLink" fluid ></b-img>
      </div>
    </b-modal>

    <!-- show img loop -->
    <b-modal ref="img-list" hide-footer centered size="lg">
      <b-row>
        <b-col v-for="(item,index) in imgLinkList" :key="index" class="col-12 col-md-6 pb-1">
          <b-img :src="item" fluid width="370px"></b-img>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BAvatar, BContainer, BLink, BTable,
  BSpinner, BImg, BFormCheckbox, BTooltip, BFormRadioGroup, BFormRadio, BFormGroup, BForm, BFormFile,
  BFormInput, BFormTextarea, BPagination
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import { format_price, formatDatetime, isNumberWithDot } from '@/views/global_function.js'
import axios from "axios";
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
export default {
  name: 'Taobao2youFlashpayChinaPayment',

  directives: {
    'b-toggle': VBToggle,
  },

  components: {
    BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BAvatar, BContainer, BLink, BTable,
    BSpinner, BImg, BFormCheckbox, BTooltip, BFormRadioGroup, BFormRadio, BFormGroup, BForm, BFormFile, BFormInput,
    flatPickr, BFormTextarea, Cleave, BPagination
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      balanceUser: [],
      exchangeFee: [],
      exChangeRate: [],

      //table
      date: null,
      dueDate: null,
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },
      paymentList: [],
      paymentFields: [
        { key: 'id', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'statusText', label: 'สถานะ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'created', label: 'วันที่สร้าง', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'amount', label: 'ยอดเงิน', thClass: 'text-center', tdClass: 'text-right' },
        { key: 'paymentMethod', label: 'ฝากจ่าย/โอน', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'remark', label: 'หมายเหตุ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'photoLink', label: 'รูปออเดอร์', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'transferSlip', label: 'สลิป', thClass: 'text-center', tdClass: 'text-center' },
      ],

      //paging history
      perPage: 10,
      currentPage: 1,
      totalRows: 0,

      //step
      stepPay: 0,

      //china
      payWebSel: '',
      payWebList: [
        { text: 'Taobao', value: 'Taobao' },
        { text: '1688', value: '1688' },
      ],
      depositAmount: '',
      valPayWebSel: true,
      valDepositAmount: true,

      chinaAmount: '',
      chinaRemark: '',
      valChinaAmount: true,
      valChinaRemark: true,

      alipayAmount: '',
      alipayRemark: '',
      valAlipayAmount: true,
      valAlipayRemark: true,

      imgFile: null,
      imgOnce: null,
      imgList: [],
      imgUrlList: [],

      chooseMethod: 1,
      paymentMethod: [
        { text: 'ฝากจ่าย + ขอเลขฝากจ่าย', value: 1 },
        { text: 'โอนบัญชีจีน', value: 2 },
        { text: 'โอน Alipay', value: 3 },
      ],

      confirmID: null,
      confirmParAmount: '',
      confirmParMeth: '',
      confirmAmount: '',
      confirmSlip: null,
      valConfirmAmount: true,

      checkParConfirmID: null,

      //show img
      imgLink: '',
      imgLinkList: [],

      //yuan topup
      amountBaht: '',
      amountYuan: '',
      valAmountYuan: true,

      checkBalanceฺBaht: true,

      //load
      loadpage: true,
      loadbtn: true,
    };
  },

  async created() {
    this.loadpage = false
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = await urlParams.get('id')
    await this.getBalance()
    await this.getTransferList()
    var once = await this.getOnceTransfer(id)
    if (id != null && once.statusID == 2) {
      this.confirmID = id
      this.confirmParAmount = once.amount
      this.confirmParMeth = once.paymentMethod
      this.checkParConfirmID = id
      this.$refs['update-transfer'].show()
    } else if (id != null && once.statusID != 2) {
      this.$swal({
        title: 'คุณได้ทำรายการแล้ว !',
        text: "คุณได้กดยืนยันรายการฝากจ่ายนี้แล้ว !",
        icon: 'info',
        showCancelButton: false,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-info',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          this.$router.push({path: '/finance/china-payment'})
        }
      })
    }
    await this.getFeeList()
    await this.getExchangeRate()
    this.loadpage = true
  },

  watch: {
    async imgFile() {
      var fileBase64 = null
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
      if (this.imgFile != null && this.imgFile != undefined) {
        fileBase64 = await toBase64(this.imgFile)
        this.imgList.push({
          'img64': fileBase64,
          'img': this.imgFile
        })
      }
    },
    amountBaht() {
      var baht = Number(this.amountBaht)
      if (this.balanceUser.balanceBaht < baht) {
        this.checkBalanceฺBaht = false
      } else {
        this.checkBalanceฺBaht = true
      }
    },
    async currentPage() {
      await this.getBillHistory()
    },
  },

  methods: {
    //topup balance baht
    toTopupBalance() {
      localStorage.setItem('auto-topup', true)
      window.open('/finance/payment', "_self");
    },

    // topup balance yuan
    closeTopupBalance() {
      this.amountBaht = ''
      this.amountYuan = ''
      this.valAmountYuan = true
      this.$refs['topup'].hide()
    },

    //
    format_price,
    formatDatetime,
    isNumberWithDot,
    pressBaht() {
      var yuan = ((parseFloat(this.amountBaht) - parseFloat(this.exchangeFee.numberValues)) / parseFloat(this.exchangeRate.topUpRate)).toFixed(2)
      if (this.amountBaht == '' || yuan <= 0) {
        this.amountYuan = ''
      } else {
        this.amountYuan = yuan
      }
    },
    pressYuan() {
      var baht = ((parseFloat(this.amountYuan) * parseFloat(this.exchangeRate.topUpRate)) + parseFloat(this.exchangeFee.numberValues)).toFixed(2)
      if (this.amountYuan == '' || baht <= 0) {
        this.amountBaht = ''
      } else {
        this.amountBaht = baht
      }
    },
    async getBalance() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/Balance/get-customer-balance?LoginToken=' + this.userData.data.customerInfo.loginToken,
        { headers: header_token }
      );
      this.balanceUser = response.data
    },

    async getFeeList() {
      let response = await axios.get(
        taobaoService_dotnet + 'api/General/get-fee-list',
        // 'https://localhost:5001/api/General/get-fee-list',
        { headers: header_token }
      );
      this.exchangeFee = response.data[1]
    },

    async getExchangeRate() {
      let response = await axios.post(
        taobaoService_dotnet + 'api/General/get-exchange-rate',
        { headers: header_token }
      );
      this.exchangeRate = response.data
    },

    async getTransferList() {
      var skip = 0
      skip = (this.currentPage - 1) * 10

      let response = await axios.post(
        taobaoService_dotnet + 'app/ChinaTransferBank/get-china-transfer',
        // 'https://localhost:5001/app/ChinaTransferBank/get-china-transfer',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "startDate": this.date,
          "endDate": this.dueDate,
          "skip": skip,
          "take": 10
        },
        { headers: header_token }
      );
      this.date = response.data.startDate
      this.dueDate = response.data.endDate
      this.totalRows = response.data.totalRows
      this.paymentList = response.data.dataList
    },

    async getOnceTransfer(id) {
      let response = await axios.post(
        taobaoService_dotnet + 'app/ChinaTransferBank/get-once-transfer',
        // 'https://localhost:5001/app/ChinaTransferBank/get-once-transfer',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "id": Number(id)
        },
        { headers: header_token }
      );
      return response.data
    },

    async createTransfer() {
      var reqApi = false
      var amount = 0
      var remark = ''
      var meth = ''
      if (this.chooseMethod == 1) {
        if (this.payWebSel == '') {
          this.valPayWebSel = false
        } else if (this.depositAmount == '' || this.depositAmount == '0') {
          this.valDepositAmount = false
        } else if (this.imgList.length == 0) {
          this.$swal({
            title: 'คุณยังไม่ได้แนบรูปออร์เดอร์ !',
            text: "กรุณาแนบรูปออร์เดอร์ให้ครบก่อนกดยืนยัน !",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'เข้าใจแล้ว',
            customClass: {
              confirmButton: 'btn btn-warning',
            },
            buttonsStyling: false,
          })
        } else {
          reqApi = true
          amount = Number(this.depositAmount)
          meth = this.payWebSel
        }
      } else if (this.chooseMethod == 2) {
        if (this.chinaAmount == '' || this.chinaAmount == '0') {
          this.valChinaAmount = false
        } else if (this.chinaRemark.trim() == '') {
          this.valChinaRemark = false
        } else {
          reqApi = true
          amount = Number(this.chinaAmount)
          remark = this.chinaRemark
          meth = 'Bank Acoount'
        }
      } else if (this.chooseMethod == 3) {
        if (this.alipayAmount == '' || this.alipayAmount == '0') {
          this.valAlipayAmount = false
        } else if (this.alipayRemark.trim() == '') {
          this.valAlipayRemark = false
        } else {
          reqApi = true
          amount = Number(this.alipayAmount)
          remark = this.alipayRemark
          meth = 'Alipay'
        }
      }

      if (reqApi == true) {
        this.loadbtn = false
        if (this.chooseMethod == 1) {
          for (let index = 0; index < this.imgList.length; index++) {
            await this.addPhoto(this.imgList[index].img)
          }
        } else {
          if (this.imgOnce != null) {
            await this.addPhoto(this.imgOnce)
          }
        }

        let response = await axios.post(
          taobaoService_dotnet + 'app/ChinaTransferBank/create-china-transfer',
          // 'https://localhost:5001/app/ChinaTransferBank/create-china-transfer',
          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "amount": amount,
            "photoLink": this.imgUrlList,
            "remark": remark,
            "paymentMethod": meth
          },
          { headers: header_token }
        );

        if (response.data == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'สร้างรายการโอนเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })

          this.getTransferList()
          this.$refs['china-transfer'].hide()
          this.closeChooseList()
        }
        this.loadbtn = true
      }
    },

    async updateTransfer() {
      if (this.confirmAmount == '' || this.confirmAmount == '0') {
        this.valConfirmAmount = false
      } else {
        this.loadbtn = false
        var slip = await this.addPhoto(this.confirmSlip, true)
        let response = await axios.post(
          taobaoService_dotnet + 'app/ChinaTransferBank/confirm-china-transfer',
          // 'https://localhost:5001/app/ChinaTransferBank/confirm-china-transfer',
          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "id": this.confirmID,
            "confirmAmount": Number(this.confirmAmount),
            "transferSlip": slip,
          },
          { headers: header_token }
        );
        if (response.data == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'ยืนยันการโอนเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })

          this.getTransferList()
          this.closeUpdate()
        }
        this.loadbtn = true
      }
    },

    async exchangeBahtToYuan() {
      if (Number(this.amountBaht) > this.balanceUser.balanceBaht) {
        this.$swal({
          title: 'ยอดเงินของคุณไม่เพียงพอ !',
          text: 'กรุณากรอกยอดเงินให้พอดีหรือน้อยกว่ายอดเงินบาทที่มี',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'เข้าใจแล้ว',
          customClass: {
            confirmButton: 'btn btn-warning',
          },
          buttonsStyling: false,
        })
      } else {
        this.loadbtn = false

        let response = await axios.post(
          taobaoService_dotnet + 'app/Balance/exchange-baht-to-yuan',
          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "amountBaht": Number(this.amountBaht),
            "exchangeRate": this.exchangeRate.topUpRate,
            "exchangeFee": this.exchangeFee.numberValues,
            "amountYuan": Number(this.amountYuan)
          },
          { headers: header_token }
        );
        if (response.data.status == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แลกเงินหยวนเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          await this.$router.push({path: '/'})
          this.$router.push({path: '/finance/china-payment'})
        } else if(response.data.status == 'error') {
          this.$swal({
            title: response.data.error_description,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'เข้าใจแล้ว',
            customClass: {
              confirmButton: 'btn btn-warning',
            },
            buttonsStyling: false,
          })
        }
      }
      this.loadbtn = true
    },

    async deleteTransfer(id) {
      this.$swal({
        title: 'ลบรายการฝากจ่าย/โอนเงิน ?',
        text: "คุณแน่ใจหรือไม่ว่าต้องการลบรายการฝากจ่าย/โอนเงิน ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/ChinaTransferBank/delete-china-transfer',
            // 'https://localhost:5001/app/ChinaTransferBank/delete-china-transfer',
            {
              "customerID": JSON.parse(localStorage.getItem('cusId')),
              "id": id,
            },
            { headers: header_token }
          );
          if (response.data == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'ลบรายการฝากจ่าย/โอนเงินเรียบร้อย',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
            })
            this.getTransferList()
          }
        }
      })
    },

    popupUpdate(item) {
      this.confirmID = item.id
      this.confirmParAmount = item.amount
      this.confirmParMeth = item.paymentMethod
      this.$refs['update-transfer'].show()
    },

    async nextStep(count) {
      this.stepPay = count
    },
    async removeImg(info) {
      this.imgList = this.imgList.filter(function(item) {
        return item !== info
      })
    },
    async closeChooseList() {
      this.chooseMethod = 1
      this.stepPay = 0

      this.payWebSel = ''
      this.depositAmount = ''

      this.chinaAmount = ''
      this.chinaRemark = ''

      this.alipayAmount = ''
      this.alipayRemark = ''

      this.valPayWebSel = true
      this.valDepositAmount = true
      this.valChinaAmount = true
      this.valChinaRemark = true
      this.valAlipayAmount = true
      this.valAlipayRemark = true

      this.loadbtn = true

      this.imgFile = null
      this.imgOnce = null
      this.imgList = []
      this.imgUrlList = []
    },

    closeUpdate() {
      this.confirmID = null
      this.confirmAmount = ''
      this.confirmParAmount = ''
      this.confirmParMeth = ''
      this.confirmSlip = null
      this.valConfirmAmount = true

      this.loadbtn = true

      if (this.checkParConfirmID != null) {
        this.$router.push({path: '/finance/china-payment'})
      }
      this.checkParConfirmID = null
      this.$refs['update-transfer'].hide()
    },

    //show img
    async showImg(img) {
      this.imgLink = await img
      this.$refs['show-img'].show()
    },
    async showImgList(img) {
      this.imgLinkList = await img
      this.$refs['img-list'].show()
    },

    //add photo
    async addPhoto(item, update) {
      var imgLink = null
      var FormData = require('form-data');
      var data = new FormData();
      data.append('', item);
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'api/General/upload-file-with-type?UploadType=8',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json',
        },
        data : data
      };
      await axios(config)
      .then(function (response) { imgLink = response.data })
      .catch(function (error) { console.log(error); });
      if (update == true) {
        return imgLink[0]
      }
      this.imgUrlList.push(imgLink[0])
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style>
.clr-text{
  color:gray!important
}
</style>